/**
 * Appends contact-organizer query params for redirects to `/o/{organizerId}`.
 */
export function withContactOrganizerQuery(url: string, eventId: string): string {
  const sep = url.includes('?') ? '&' : '?';
  const fallbackHref = `${url}${sep}contact_organizer=true&event_id=${encodeURIComponent(eventId)}`;

  try {
    const parsedUrl = new URL(url, 'https://www.eventbrite.com');
    parsedUrl.searchParams.set('contact_organizer', 'true');
    parsedUrl.searchParams.set('event_id', eventId);

    if (url.startsWith('http://') || url.startsWith('https://')) {
      return parsedUrl.toString();
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return fallbackHref;
  }
}
